<section class="row">
  <div class="col-12 d-flex justify-content-start"
       [ngClass]="{
         'align-items-top': hasDescription,
         'align-items-center': !hasDescription}">
    <div>
      <i-feather name="check-circle"
                 class="icon-check-circle text-primary me-3"></i-feather>
    </div>
    <div>
      <h2 class="h4 fw-bolder"
          [ngClass]="{'mb-0': !hasDescription}"
          [translate]="'BOOKING-PART.COMPLETED-ITEMS-INFO.PAYMENT-SUCCESSFUL.TITLE'">
      </h2>
      <p *ngIf="hasDescription"
         class="subtitle pre-wrap"
         [translate]="'BOOKING-PART.COMPLETED-ITEMS-INFO.PAYMENT-SUCCESSFUL.DESCRIPTION'"></p>
    </div>
  </div>
</section>
